export const ExperimentAPINames = {
  ContextualPaywallMessaging: "Contextual Paywall Messaging",
  HigherPaywall: "Higher Paywall",
  HPMostPopularArticleLabel: "Most popular article label",
  LTSHardPaywall: "LTS 70 Hard Paywall",
  PaywallMasking: "Paywall Masking",
  SubNavTrendingLabel: "SubNav Trending Label",
  VelocityWallThreshold: "Velocity Wall Threshold",
};
